import React from "react";

//import MUI
import { Modal } from "antd";
import Skeleton from "@mui/material/Skeleton";

const TableSize = (props) => {
  const { openModal, setOpenModal, selectedMaterial } = props;

  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  React.useEffect(() => {
    setIsImageLoaded(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMaterial]);
  return (
    <Modal
      title="جدول سایزبندی تیشرت انتخابی"
      centered
      open={openModal}
      onOk={() => setOpenModal(false)}
      onCancel={() => setOpenModal(false)}
      okText={"تایید"}
      cancelText="انصراف"
    >
      <div className="row justify-content-center">
        <hr className="p-0 mb-2" />
        <div className="row mb-5 justify-content-center ">
          {selectedMaterial.Image2 ? (
            <div className="col-12 p-0  text-center">
              <Skeleton
                sx={{ borderRadius: "10px", marginTop: "15px" }}
                className={isImageLoaded ? "d-none" : "d-block"}
                animation="wave"
                variant="rounded"
                width={"100%"}
                height={455}
              />
              <img
                className={isImageLoaded ? "d-block" : "d-none"}
                width={"100%"}
                src={selectedMaterial.Image2.mediaUrl}
                alt="First slide"
                onLoad={() => setIsImageLoaded(true)}
              />
            </div>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};
export default TableSize;
